import React, { useMemo } from 'react';

const getPickupActiveQty = (component = {}) => {
  const materialQty = Number(component.quantity || 0);
  const goodQty = Number(component.liftedGood || 0);
  const damageQty = Number(component.liftedDamage || 0);
  const missingQty = Number(component.finalMissing || 0);

  return Math.max(0, materialQty - goodQty - damageQty - missingQty);
};

const renderVal = (val) => (val === 0 || val === '0' || !val ? '' : val);

const PCPreviewContent = ({
  pcData,
  selectedFirm,
  printRef,
  style = pdfContainerStyle
}) => {
  const handoverDateTime = pcData?.handedOverBy?.dateTime
    || [pcData?.handedOverBy?.handoverDate || '', pcData?.handedOverBy?.handoverTime || ''].filter(Boolean).join(' ');
  const warehouseReceivedDateTime = pcData?.receivedAt
    || [pcData?.receivedDate || '', pcData?.receivedTime || ''].filter(Boolean).join(' ');

  const totals = useMemo(() => {
    return (pcData?.components || []).reduce((acc, component) => {
      acc.quantity += Number(component.quantity || 0);
      acc.liftedGood += Number(component.liftedGood || 0);
      acc.liftedDamage += Number(component.liftedDamage || 0);
      acc.finalMissing += Number(component.finalMissing || 0);
      acc.totalLifted += Number(component.totalLifted || 0);
      acc.totalActive += getPickupActiveQty(component);
      return acc;
    }, { quantity: 0, liftedGood: 0, liftedDamage: 0, finalMissing: 0, totalLifted: 0, totalActive: 0 });
  }, [pcData]);

  if (!pcData) return null;

  return (
    <div style={style} ref={printRef}>
      <table style={headerTableStyle}>
        <tbody>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '20%', textAlign: 'center' }}>
              {selectedFirm?.logo && <img src={selectedFirm.logo} alt="Logo" style={{ maxWidth: '120px' }} />}
            </td>
            <td style={{ ...headerTableCellStyle, width: '50%', fontSize: '12px' }}>
              <strong style={{ fontSize: '16px' }}>{selectedFirm?.name}</strong><br />
              {selectedFirm?.address}<br />
              GSTIN: {selectedFirm?.gstin}
            </td>
            <td style={{ ...headerTableCellStyle, width: '30%', textAlign: 'center' }}>
              <h1 style={{ margin: 0, fontSize: '22px', fontWeight: '900' }}>PICKUP CHALLAN</h1>
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td colSpan="2" style={{ ...headerTableCellStyle, width: '60%' }}>Document Details</td>
            <td style={{ ...headerTableCellStyle, width: '40%' }}>Reference Details</td>
          </tr>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '25%' }}><strong>PC Number:</strong></td>
            <td style={{ ...headerTableCellStyle, width: '35%' }}>{pcData.pickupChallanNo || pcData.pcNo}</td>
            <td rowSpan="5" style={{ ...headerTableCellStyle, width: '40%', verticalAlign: 'top' }}>
              <div style={{ marginBottom: '10px' }}><strong>Against DC#:</strong> {pcData.deliveryChallanNo || pcData.referenceNo}</div>
              <div><strong>DC Dated:</strong> {pcData.dcDate || 'N/A'}</div>
            </td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Pickup Date:</strong></td>
            <td style={headerTableCellStyle}>{pcData.pickupDate}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Intimation Date:</strong></td>
            <td style={headerTableCellStyle}>{pcData.intimationDate || 'N/A'}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Pickup Agent:</strong></td>
            <td style={headerTableCellStyle}>{pcData.pickupAgent}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Coordinator:</strong></td>
            <td style={headerTableCellStyle}>{pcData.coordinator}</td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>Consignee (Billing)</td>
            <td style={{ ...headerTableCellStyle, width: '50%' }}>Pickup Location (Site)</td>
          </tr>
          <tr>
            <td style={{ ...headerTableCellStyle, height: '80px', verticalAlign: 'top', whiteSpace: 'pre-wrap' }}>
              <strong>Customer:</strong> {pcData.billingCustomerName}<br />
              <strong>Address:</strong> {pcData.billingAddress}
            </td>
            <td style={{ ...headerTableCellStyle, height: '80px', verticalAlign: 'top', whiteSpace: 'pre-wrap' }}>
              <strong>Customer:</strong> {pcData.siteCustomerName}<br />
              <strong>Project:</strong> {pcData.siteProjectName}<br />
              <strong>Location:</strong> {pcData.siteAddress}
            </td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}>
              <strong>GSTIN/UIN:</strong> {pcData.gstin}
            </td>
            <td style={headerTableCellStyle}>
              <strong>Salesperson:</strong> {pcData.salesperson}
            </td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}>
              <strong>Order By:</strong> {pcData.orderBy?.name}<br />
              <strong>Contact:</strong> {pcData.orderBy?.contact}<br />
              <strong>Email:</strong> {pcData.orderBy?.email}
            </td>
            <td style={headerTableCellStyle}>
              <strong>Site Person:</strong> {pcData.sitePerson?.name}<br />
              <strong>Contact:</strong> {pcData.sitePerson?.contact}<br />
              <strong>Email:</strong> {pcData.sitePerson?.email}
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr>
            <td style={{ ...headerTableCellStyle, padding: '10px' }}>
              <strong>Remarks:</strong> {pcData.remarks || 'No remarks provided.'}
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <thead>
          <tr style={{ backgroundColor: '#f8fafc' }}>
            <th style={pdfThStyle}>Sr.</th>
            <th style={pdfThStyle}>SKU</th>
            <th style={{ ...pdfThStyle, textAlign: 'left' }}>Description</th>
            <th style={pdfThStyle}>Material Qty</th>
            <th style={pdfThStyle}>Good Condition</th>
            <th style={pdfThStyle}>Damage Condition</th>
            <th style={pdfThStyle}>Missing Qty</th>
            <th style={pdfThStyle}>Total Lifted</th>
            <th style={pdfThStyle}>Total Active</th>
          </tr>
        </thead>
        <tbody>
          {pcData.components?.map((component, index) => (
            <tr key={index}>
              <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{index + 1}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{component.sku}</td>
              <td style={pdfTdStyle}>{component.name || component.description}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(component.quantity)}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(component.liftedGood)}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(component.liftedDamage)}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(component.finalMissing)}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center', fontWeight: 'bold' }}>{renderVal(component.totalLifted)}</td>
              <td style={{ ...pdfTdStyle, textAlign: 'center', fontWeight: 'bold' }}>{renderVal(getPickupActiveQty(component))}</td>
            </tr>
          ))}
          <tr style={{ backgroundColor: '#f8fafc', fontWeight: 'bold' }}>
            <td colSpan="3" style={{ ...pdfTdStyle, textAlign: 'right' }}>Total:</td>
            <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(totals.quantity)}</td>
            <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(totals.liftedGood)}</td>
            <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(totals.liftedDamage)}</td>
            <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(totals.finalMissing)}</td>
            <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(totals.totalLifted)}</td>
            <td style={{ ...pdfTdStyle, textAlign: 'center' }}>{renderVal(totals.totalActive)}</td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '30%' }}><strong>Handed Over By:</strong></td>
            <td style={{ ...headerTableCellStyle, width: '30%' }}>{pcData.handedOverBy?.name || ''}</td>
            <td rowSpan="3" style={{ ...headerTableCellStyle, width: '40%', textAlign: 'right', verticalAlign: 'bottom', padding: '15px' }}>
              <strong>Customer Seal & Signature</strong>
            </td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Received By:</strong></td>
            <td style={headerTableCellStyle}>{pcData.handedOverBy?.receivedBy || ''}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Date & Time of Handover:</strong></td>
            <td style={headerTableCellStyle}>{handoverDateTime ? handoverDateTime.replace('T', ' ') : ''}</td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td style={{ ...headerTableCellStyle, fontSize: '13px' }}>Terms and Conditions</td>
          </tr>
          <tr>
            <td style={{ ...headerTableCellStyle, fontSize: '10px', lineHeight: '1.5', whiteSpace: 'pre-wrap' }}>
              1. Pickup requests must be confirmed through our designated channels. Verbal requests or informal communications may not be considered confirmed until processed through our official booking system.<br />
              2. Requests for cancellation or rescheduling of pickup must be made within the specified timeframe, as outlined in our cancellation policy. Failure to notify us within this timeframe may result in cancellation fees.<br />
              3. While every effort is made to handle items with care, we are not liable for any damage, loss, or delay incurred during the pickup process, unless caused by our negligence or misconduct.<br />
              4. Any disputes or discrepancies regarding pickuped up material i.e Missing items and damaged items shall be resolved through mutual discussion. In case of unresolved disputes, the matter may be escalated to arbitration or legal proceedings as per applicable laws and regulations.
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ ...headerTableStyle, borderTop: 'none' }}>
        <tbody>
          <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
            <td colSpan="3" style={{ ...headerTableCellStyle, textAlign: 'center' }}>Internal Purpose Only (Warehouse Receipt)</td>
          </tr>
          <tr>
            <td style={{ ...headerTableCellStyle, width: '30%' }}><strong>Received at Warehouse by:</strong></td>
            <td style={{ ...headerTableCellStyle, width: '30%' }}>{pcData.receivedBy || ''}</td>
            <td rowSpan="3" style={{ ...headerTableCellStyle, width: '40%', textAlign: 'right', verticalAlign: 'bottom', padding: '5px' }}>
              <strong style={{ fontSize: '14px' }}>For {selectedFirm?.name}</strong>
            </td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Time & Date:</strong></td>
            <td style={headerTableCellStyle}>{warehouseReceivedDateTime ? warehouseReceivedDateTime.replace('T', ' ') : ''}</td>
          </tr>
          <tr>
            <td style={headerTableCellStyle}><strong>Verified & Checked by:</strong></td>
            <td style={headerTableCellStyle}>{pcData.verifiedBy || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const pdfContainerStyle = { backgroundColor: 'white', padding: '40px', border: '1px solid #e2e8f0', minHeight: '1000px', color: '#000' };
const headerTableStyle = { width: '100%', borderCollapse: 'collapse', border: '1px solid #000' };
const headerTableCellStyle = { border: '1px solid #000', padding: '8px', fontSize: '12px' };
const pdfThStyle = { border: '1px solid #000', padding: '6px', fontSize: '11px', textAlign: 'center', fontWeight: 'bold' };
const pdfTdStyle = { border: '1px solid #000', padding: '6px', fontSize: '11px', textAlign: 'left' };

export default PCPreviewContent;
